import React from "react"
const FormFooterButton = ({ clickFn, label, enabled }) => {
	return <button className={`form-footer__button ${enabled ? 'form-footer__button--enabled' : ''}`} onClick={clickFn}>{label}</button>
}
export default FormFooterButton